import React from 'react'
import { requestRoot } from 'services/ReviewService'
import connect from 'libraries/front-end-core/decorators/connect'
import AccordionWrapperContainer from 'redux/containers/components/accordion/AccordionWrapperContainer'

const AccordionWrapper = ({ flavour, ...props }) => {
  const cxNames = {
    groupHeader: {
      onHoverColor: `hover-bg-flavour-${flavour}`,
      depthStyle: (depth) => {
        switch (depth) {
          case 1:
            return 'bg-suez-canal white b--eastern-breeze hover-underline'
          case 2:
            return 'bg-powder-white b--eastern-breeze hover-underline'
          default:
            return 'bg-powder-white b--twilight-grey hover-underline'
        }
      },
      iconDepthStyle: () => 'cadet-blue'
    },
    borderColor: 'b--suez-canal',
    content: {
      divider: 'bt--eastern-breeze'
    },
    contentHeader: {
      headerBackground: 'bg-white'
    }
  }
  return <AccordionWrapperContainer {...{ flavour, cxNames, ...props }} />
}

export default connect(
  ({ flavour, sectionId, selectedIds }) => ({ group: requestRoot({ flavour, sectionId, selectedIds }) })
)(AccordionWrapper)
